<template>
  <section class="labs-experience-main">
    <template v-if="showSkillDive">
      <LabExperienceEnhanced />
    </template>
    <template v-else>
      <LabExperienceRegular />
    </template>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import LabExperienceEnhanced from '@/components/lab-experience/LabExperienceEnhanced.vue'
import LabExperienceRegular from '@/components/lab-experience/LabExperienceRegular.vue'

export default {
  name: 'LabsExperience',
  components: {
    LabExperienceEnhanced,
    LabExperienceRegular,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.showSkillDive) {
        if (vm.$route.name === 'lab-experience') next('/dive')
      } else if (vm.isLabExperienceLegacyB2BUser) {
        if (vm.$route.name === 'skill-dive') next('/lab-experience')
      } else {
        // if not a legacy LE or SD user
        next('/home')
      }
    })
  },
  computed: {
    ...mapGetters({
      isLabExperienceLegacyB2BUser: 'auth/isLabExperienceLegacyB2BUser',
      showSkillDive: 'labExperience/showSkillDive',
    }),
  },
}
</script>
